export default __webpack_public_path__ + "static/media/blackSos.fbafc897.svg";